import { createFileRoute, redirect } from '@tanstack/react-router';
import AssistantSettings from '@/pages/AssistantSettings';
import { supabase } from '@/lib/supabase';

export const Route = createFileRoute('/assistant-settings')({
  component: AssistantSettings,
  beforeLoad: async () => {
    // Check if user is authenticated with Supabase
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.user) {
      // Not authenticated - redirect to home
      throw redirect({ to: '/' });
    }

    // Check if user is an assistant
    const userType = session.user.user_metadata?.['user_type'];
    if (userType !== 'assistant') {
      // Not an assistant - redirect to appropriate page
      throw redirect({ to: '/' });
    }
  },
});
